module.exports = __webpack_public_path__ + "img/about_2016.8cccefd3.png";